
import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';


import { ServiceBase } from '@app/services/base.service';
import { Unidade } from '@app/models/unidade.model';
@Injectable()
export class UnidadeService extends ServiceBase {
  constructor(
    private http: HttpClient,
  ) {
    super();
  }

  gravar(unidade: Unidade) {
    return this.http
      .post(this.URL_API + 'configuracoes/unidade', unidade).pipe(
        catchError((error: any) => observableThrowError(error)));
  }


  deletar(id: number): Observable<any> {
    return this.http
      .delete<any>(this.URL_API + `configuracoes/unidade/${id}`);
  }

  obterPorId(id: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `configuracoes/unidade/${id}`);
  }


  obterLista(descricao: string, pagina: number): Observable<any> {
    descricao = encodeURIComponent(descricao);
    return this.http
      .get<any>(this.URL_API + `configuracoes/unidade/lista/?descricao=${descricao}&pagina=${pagina}`, { headers: { meta: ['search'] }});
  }


  obterUnidadeUsuarioLogado(): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `unidade/ObterUnidadeUsuarioLogado/`);
  }

  // obterListaUnidade(unidadesApenasDoUsuario: boolean): Observable<any> {
  //   return this.http
  //     .post<any>(this.URL_API + `unidade/ObterListaUnidades/?unidadesApenasDoUsuario=${unidadesApenasDoUsuario}`);
  // } TODO: NÃO ESTÁ IMPLEMENTADO NA API

  // // obterUsuarioLogado(){
  // //   return this.http.get(this.URL_API + `unidade/ObterUsuarioLogado/`, this.obterAutorizacao())
  // //   .map((res: Response) => res.json());
  // // } TODO: NÃO ESTÁ IMPLEMENTADO NA API
}
